import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';

import OrderAppLib from 'dimorder-orderapp-lib';
import enUS from './locales/en-US';
import thTH from './locales/th-TH';
import zhHK from './locales/zh-HK';
import zhTW from './locales/zh-TW';

const locale = OrderAppLib.libs.createLocaleHelper({
  getCountryFromStore() {
    return localStorage.getItem('i18nextLng');
  },
});
let i18nextLng = localStorage.getItem('i18nextLng');
const langInit = localStorage.getItem('langInit');

if (!i18nextLng) {
  if (!langInit) {
    // 若沒有設定過語言，則使用偏好語言作為預設語言
    i18nextLng = locale.getPreferredLanguageCode();
    localStorage.setItem('langInit', 'true');
  } else {
    // 如果已經初始化過但沒有語言設定，使用預設值
    i18nextLng = 'zh-HK';
  }
  localStorage.setItem('i18nextLng', i18nextLng);
}

const resources = {
  'en-US': {
    translation: enUS,
  },
  'zh-HK': {
    translation: zhHK,
  },
  'zh-TW': {
    translation: zhTW,
  },
  'th-TH': {
    translation: thTH,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: i18nextLng,
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
